import { AsyncPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  QueryList,
  TemplateRef,
  Type
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FormlyFieldSelectProps, FormlySelectModule } from '@ngx-formly/core/select';
import { AutoComplete } from '@openng/optimus-ui/autocomplete';
import { TemplateDirective } from '~ngx-shared/directives';
import { TemplateUtil } from '~ngx-shared/utils';
import { FieldWrapperProps } from '../../wrappers/field-wrapper/field-wrapper.component';

export interface AutoCompleteProps extends FieldWrapperProps, FormlyFieldSelectProps {
  virtualScroll?: boolean;
  virtualScrollSize?: number;
  showClear?: boolean;
  forceSelection?: boolean;
  multiple?: boolean;
  optionLabel?: string | (string | ((item: any) => string));
  optionValue?: string | (string | ((item: any) => string));

  completeMethod?(
    event: { originalEvent: Event; query: string },
    field: FieldTypeConfig<AutoCompleteProps>
  ): void;
}

export interface AutoCompleteFieldConfig extends FormlyFieldConfig<AutoCompleteProps> {
  type?: 'autocomplete' | Type<AutoCompleteTypeComponent>;
}

@Component({
  selector: 'lib-formly-auto-complete-type',
  templateUrl: './auto-complete-type.component.html',
  styleUrl: './auto-complete-type.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgTemplateOutlet,
    TranslocoDirective,
    AutoComplete,
    ReactiveFormsModule,
    FormlyModule,
    NgClass,
    AsyncPipe,
    FormlySelectModule
  ]
})
export class AutoCompleteTypeComponent
  extends FieldType<FieldTypeConfig<AutoCompleteProps>>
  implements AfterContentInit
{
  @ContentChildren(TemplateDirective) templates: QueryList<TemplateDirective>;

  protected readonly optionValueOf = TemplateUtil.getOptionValue;

  headerTemplate: TemplateRef<any> | null = null;
  emptyTemplate: TemplateRef<any> | null = null;
  selectedTemplate: TemplateRef<any> | null = null;
  suggestionTemplate: TemplateRef<any> | null = null;
  footerTemplate: TemplateRef<any> | null = null;

  ngAfterContentInit(): void {
    TemplateUtil.setTemplates(this, this.templates, [
      {
        template: 'headerTemplate',
        name: 'header'
      },
      {
        template: 'suggestionTemplate',
        name: 'suggestion'
      },
      {
        template: 'selectedTemplate',
        name: 'selected'
      },
      {
        template: 'emptyTemplate',
        name: 'empty'
      },
      {
        template: 'footerTemplate',
        name: 'footer'
      }
    ]);
  }

  getValueAsString(data: any, field: string): string {
    return TemplateUtil.getValueAsString(data, field);
  }
}
